<template>
  <div>
    <Navigation />
    <Carousel />
    <MainContent />
    <AboutUs />
    <AboutUs2 />
    <Services />
<!--    <Video />-->
    <Resources />
    <Team />
    <Testimonials />
    <Contact />
  </div>
</template>

<script>
import Carousel from '@/components/CarouselPage.vue';
import Navigation from '@/components/NavigationPage.vue';
import MainContent from '@/components/MainContentPage.vue';

import AboutUs2 from '@/components/AboutUs2Page.vue';
import AboutUs from '@/components/AboutUsPage.vue';
import Services from '@/components/ServicesPage.vue';
// import Video from '@/components/VideoPlayer.vue';
import Resources from '@/components/ResourcesPage.vue';
import Team from '@/components/TeamPage.vue';
import Testimonials from '@/components/TestimonialsPage.vue';
import Contact from '@/components/ContactPage.vue';

export default {
  components: {
    Carousel,
    Navigation,
    MainContent,
    AboutUs,
    AboutUs2,
    Services,
    // Video,
    Resources,
    Team,
    Testimonials,
    Contact
  }
};
</script>

